import React from "react";
import { SimpleSelect } from "@instructure/ui-simple-select";
import { TextInput } from "@instructure/ui-text-input";

export default function StatsSearch({
  searchBy,
  onSearchByChange,
  placeholder,
  renderFilterInput,
}) {
  return (
    <div className="stats-search">
      <SimpleSelect isInline onChange={onSearchByChange}>
        <SimpleSelect.Group renderLabel="Tìm kiếm theo" key="grp1">
          <SimpleSelect.Option id="opt1" value="teacher">
            Giáo viên
          </SimpleSelect.Option>
          <SimpleSelect.Option id="opt2" value="subject">
            Môn học
          </SimpleSelect.Option>
        </SimpleSelect.Group>
      </SimpleSelect>
      <div>
        {renderFilterInput ? (
          renderFilterInput()
        ) : (
          <TextInput placeholder={placeholder} onChange={() => {}} />
        )}
      </div>
    </div>
  );
}
